"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledNavigationMenuItemIcon = exports.StyledNavigationMenuItemText = exports.StyledNavigationMenuItemBlock = exports.StyledNavigationMenuItemLink = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../../helpers");
const Icon_1 = require("../../../Icon");
const Text_1 = require("../../../Text");
const ITEM_HEIGHT = helpers_1.SIZE_XL;
const LEFT_BORDER_WIDTH = helpers_1.SIZE_XS;
const RIGHT_BORDER_WIDTH = helpers_1.BASE_BORDER_WIDTH;
const ANGLE_BORDER_WIDTH = '10px';
const ANGLE_HALF_HEIGHT = '10px';
const StyledNavigationMenuItem = (0, styled_components_1.css) `
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    min-height: ${ITEM_HEIGHT};
    border-right: ${RIGHT_BORDER_WIDTH} solid transparent;
    padding: ${helpers_1.SPACING_S} calc(${helpers_1.SPACING_XXL} - ${helpers_1.BASE_BORDER_WIDTH}) ${helpers_1.SPACING_S} ${helpers_1.SPACING_M};
    background-color: ${({ theme }) => theme.colorNavBackground};
    cursor: pointer;
    text-decoration: none;
    outline: none;

    &:hover {
        background-color: ${({ theme }) => theme.colorNavHover};
    }

    ${({ hideBorder, active }) => active &&
    !hideBorder &&
    (0, styled_components_1.css) `
            width: calc(100% + ${helpers_1.BASE_BORDER_WIDTH});
        `}

    ${({ active, triangleColor, theme }) => active &&
    (0, styled_components_1.css) `
            background-color: ${theme.colorNavCurrent};
            padding-left: calc(${helpers_1.SPACING_M} - ${LEFT_BORDER_WIDTH});
            border-left: ${LEFT_BORDER_WIDTH} solid ${theme.colorStripeAccent};
            border-right-color: ${theme.colorBorderMain};
            cursor: default;

            &::after {
                content: '';
                position: absolute;
                right: calc(-${helpers_1.BASE_BORDER_WIDTH});
                top: calc(50% - ${ANGLE_HALF_HEIGHT}); // TODO: Need to fix
                border-bottom: ${ANGLE_BORDER_WIDTH} solid transparent;
                border-right: ${ANGLE_BORDER_WIDTH} solid
                    ${triangleColor ? triangleColor : '#ffffff'};
                border-top: ${ANGLE_BORDER_WIDTH} solid transparent;
                height: 0;
            }

            &::before {
                content: '';
                position: absolute;
                right: 0;
                top: calc(50% - ${ANGLE_HALF_HEIGHT}); // TODO: Need to fix
                border-bottom: ${ANGLE_BORDER_WIDTH} solid transparent;
                border-right: ${ANGLE_BORDER_WIDTH} solid ${theme.colorBorderMain};
                border-top: ${ANGLE_BORDER_WIDTH} solid transparent;
                height: 0;
            }

            &:hover {
                background-color: ${theme.colorNavCurrent};
            }
        `}
`;
exports.StyledNavigationMenuItemLink = styled_components_1.default.a `
    ${StyledNavigationMenuItem};
`;
exports.StyledNavigationMenuItemBlock = styled_components_1.default.div `
    ${StyledNavigationMenuItem};
`;
exports.StyledNavigationMenuItemText = (0, styled_components_1.default)(Text_1.Text) `
    color: ${({ active, theme }) => (active ? theme.colorTextNavCurrent : theme.colorTextNavRest)};
    text-decoration: none;
`;
exports.StyledNavigationMenuItemIcon = (0, styled_components_1.default)(Icon_1.Icon) `
    margin-right: ${helpers_1.SPACING_M};
`;
//# sourceMappingURL=NavigationMenuItem.styles.js.map